import { authHeader } from '@/_helpers'

const apiUrl = process.env.VUE_APP_ROOT_API

export const promptsApi = {
  list,
  getApiKey,
  save,
  toggle,
  preview,
}

function list() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/admin/ai-agents-prompts`, requestOptions).then(handleResponse)
}

function getApiKey(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/admin/ai-agents-prompts/${id}/api-key`, requestOptions).then(handleResponse)
}

function save(prompt) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader('application/json'),
    body: JSON.stringify(prompt),
  }
  return fetch(`${apiUrl}/admin/ai-agents-prompts/${prompt.id}`, requestOptions).then(handleResponse)
}

function toggle(id, enabled) {
  const requestOptions = {
    method: 'PATCH',
    headers: authHeader('application/json'),
    body: JSON.stringify({ enabled }),
  }
  return fetch(`${apiUrl}/admin/ai-agents-prompts/${id}/toggle`, requestOptions).then(handleResponse)
}

function preview(id, content) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ content }),
  }
  return fetch(`${apiUrl}/admin/ai-agents-prompts/${id}/preview`, requestOptions).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = data || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
